// node-modules
import Barba from 'barba.js/dist/barba';
import NProgress from 'nprogress';

// constants
import { SELECTORS } from '@/scripts/constants';

// others
import { initPlugins } from '@/scripts/plugins/index';
import transition from './transition';

const defaults = {
  usePJAX: false,
};

export default class PageNavigation {
  constructor(props) {
    const options = Object.assign({}, defaults, props);

    this.usePJAX = options.usePJAX;

    PageNavigation.setup();
  }

  static setup() {
    Barba.Pjax.getTransition = () => transition;

    Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;

    Barba.Pjax.preventCheck = (evt, element) => Barba.Pjax.originalPreventCheck(evt, element) && element.closest(SELECTORS.main_wrapper);

    Barba.Dispatcher.on('linkClicked', () => NProgress.start());

    Barba.Dispatcher.on('transitionCompleted', () => NProgress.done());
  }

  init() {
    return new Promise(async (resolve) => {
      if (this.usePJAX) {
        const plugins = await initPlugins(document, this.usePJAX);
        if (plugins) {
          resolve(plugins, Barba.Pjax.start());
        }
      } else {
        resolve(initPlugins(document));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./components/PageNavigation/PageNavigation.js